import React from 'react';
import { Button, Icon, Popover } from 'antd';
import * as  commonFunc from './HotAreaMapCommon';
import { getNullMapConfig } from './HotAreaMapCommon';
import SvgIcon from 'SvgIcon';

export class HotAreaMapDisplay extends React.Component {
  constructor(props) {
    super(props);
    /*   props:
        cStyle: 数据字段的配置文件
        mapConfig ： 楼层热区图配置文件
        model ： viewModel
        // onSelectArea ： 选中区域的事件

    */
    let tmpState = {};
    let cStyle;
    if (commonFunc.isDebug) {
      cStyle = commonFunc.getDebugCStyle(false);
      tmpState.mapConfig = commonFunc.getDebugMapConfig();
    }
    else {
      cStyle = props.cStyle;
      tmpState.mapConfig = commonFunc.JSONParse(props.mapConfig) || {};
    }

    cStyle = commonFunc.JSONParse(cStyle);
    commonFunc.LogChartInfo(" 热区显示图 初始化 cStyle = " + JSON.stringify(cStyle) + "  props.mapConfig = " + JSON.stringify(props.mapConfig), 901);

    let fieldMapping = {};
    fieldMapping.codeField = cStyle.codeField || "";
    fieldMapping.stateField = cStyle.stateField || "";
    fieldMapping.captionFields = cStyle.captionFields || [];
    fieldMapping.mapConfigField = cStyle.mapConfigField || "";

    if (!fieldMapping.codeField || !fieldMapping.stateField || !fieldMapping.captionFields || fieldMapping.captionFields.length == 0 || !fieldMapping.mapConfigField) {
      commonFunc.LogChartInfo(" 热区显示图 在CStyle中未能找到全部的热区配置字段 codeField stateField captionFields mapConfigField ", 999);
    }
    tmpState.fieldMapping = fieldMapping;
    tmpState.extendClassName = cStyle.hasOwnProperty("extendClassName") ? cStyle.extendClassName : "";
    tmpState.triggerEvents = cStyle.triggerEvents;
    tmpState.refreshInterval = cStyle.hasOwnProperty("refreshInterval") ? cStyle.refreshInterval : -1;
    if (tmpState.refreshInterval <= 0) {
      commonFunc.LogChartInfo(" 热区显示图 不进行刷新。", 901);
    }
    else {
      if (tmpState.refreshInterval < 5000) {
        tmpState.refreshInterval = 5000;
        commonFunc.LogChartInfo(" 热区显示图  设置的刷新时间太短,更改为5秒。", 999);
      }
      this.setTimeInterval(tmpState.refreshInterval);
    }


    tmpState.selectedCoor = {};
    tmpState.popoverCoor = {};
    tmpState.areaDataList = [];
    this.state = tmpState;

    if (this.props.model.modelType.toLowerCase() == 'gridmodel')
      this.gridModel = this.props.model;
    else
      this.gridModel = this.props.model.getGridModel();

    // this.defaultAreaBorder = "solid 1px white";// transparent
    this.areaBackPicUrl_0 = "http://resourceyxy.yonyouup.com/34d44c87-35a8-4469-ae1a-da17a7ad2ae1.png";
    this.areaBackPicUrl_1 = "http://resourceyxy.yonyouup.com/31db3764-33bf-4fac-b156-00982cf96b5e.png";
    this.zoomInfo = { configWidth: 100, configHeight: 100, divWidth: 100, divHeight: 100, zoomRate: 1 };
    this.touchevent();

  }


  touchevent() {
    var pageX, pageY, initX, initY, isTouch = false, preScale = 1, moreScale = 0;
    var start = [];
    document.addEventListener("touchstart", function (e) {
      if (e.target.id === 'room_ext_elem_s') {
        //手指按下时的手指所在的X，Y坐标  
        pageX = e.targetTouches[0].pageX;
        pageY = e.targetTouches[0].pageY;


        //初始位置的X，Y 坐标  
        initX = e.target.offsetLeft;
        initY = e.target.offsetTop;


        //记录初始 一组数据 作为缩放使用
        if (e.touches.length >= 2) { //判断是否有两个点在屏幕上
          start = e.touches; //得到第一组两个点
        };


        //表示手指已按下  
        isTouch = true;
      }
    }, false);


    //监听 touchmove 事件 手指 移动时 做的事情
    document.addEventListener("touchmove", function (e) {
      // e.preventDefault();
      e.target.style.left = 0;
      e.target.style.top = 0;
      // 一根 手指 执行 目标元素移动 操作
      if (e.touches.length == 1 && isTouch) {

        if (e.target.id === 'room_ext_elem_s') {
          //移动目标的 X Y 坐标
          var touchMoveX = e.targetTouches[0].pageX,
            touchMoveY = e.targetTouches[0].pageY;
          //设置当前点击元素的 top left 定位值 
          let tmp = e.target.style.transform.substring(6);
          let thisScale = tmp.substring(0, tmp.length - 1);
          let leftMore = 0;
          let topMore = 0;
          if (parseFloat(thisScale) > 1) {
            leftMore = (parseFloat(thisScale) - 1) * parseInt(e.target.style.width) / 2;
            topMore = (parseFloat(thisScale) - 1) * parseInt(e.target.style.height) / 2;
          }
          if (parseInt(touchMoveX) - parseInt(pageX) < 0) {//左滑
            if (parseInt(touchMoveX) - parseInt(pageX) + parseInt(initX) < -leftMore) {
              e.target.style.left = -leftMore + "px";
            } else {
              e.target.style.left = parseInt(touchMoveX) - parseInt(pageX) + parseInt(initX) + "px";
            }

          } else {//右滑
            if (parseInt(e.target.style.left) <= leftMore) {
              if (parseInt(touchMoveX) - parseInt(pageX) + parseInt(initX) > leftMore) {
                e.target.style.left = leftMore + "px";
              } else {
                e.target.style.left = parseInt(touchMoveX) - parseInt(pageX) + parseInt(initX) + "px";
              }
            }
          }

          if (parseInt(touchMoveY) - parseInt(pageY) < 0) {//上滑
            if (parseInt(touchMoveY) - parseInt(pageY) + parseInt(initY) <= -topMore) {
              e.target.style.top = -topMore + 'px';
            } else {
              e.target.style.top = parseInt(touchMoveY) - parseInt(pageY) + parseInt(initY) + "px";
            }
          } else {
            if (parseInt(e.target.style.top) <= topMore) {//下滑
              if (parseInt(touchMoveY) - parseInt(pageY) + parseInt(initY) > topMore) {
                e.target.style.top = topMore + "px";
              } else {
                e.target.style.top = parseInt(touchMoveY) - parseInt(pageY) + parseInt(initY) + "px";
              }
            }
          }
        }
      };


      // 2 根 手指执行 目标元素放大操作
      if (e.touches.length >= 2 && isTouch && e.scale < 2.5) {

        //得到第二组两个点
        var now = e.touches;
        //得到缩放比例， getDistance 是勾股定理的一个方法
        var scale = (getDistance(now[0], now[1]) / getDistance(start[0], start[1]));
        /** 	// 对缩放 比例 取整
          e.scale = scale.toFixed(2);**/
        // 执行目标元素的缩放操作
        if (e.target.id === 'room_ext_elem_s') {
          e.target.style.transform = "scale(" + preScale + ")";
          preScale = scale + moreScale >= 1 ? scale + moreScale : 1;
          moreScale = scale + moreScale - 1;
        }

      };


    }, false);
    //监听 手指离开屏幕时 
    document.addEventListener("touchend", function (e) {
      //将 isTouch 修改为false  表示 手指已经离开屏幕
      if (isTouch) {
        isTouch = false;
      }
    }, false);

    //缩放 勾股定理方法
    function getDistance(p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt((x * x) + (y * y));
    };
  }

  setListenerState(params) {
    //处理按钮状态
    debugger;
  }

  componentDidMount() {
    if (this.gridModel)
      this.gridModel.addListener(this);
    if (commonFunc.isDebug) {
      this.controls = this.props.meta.containers[0].controls;
      this.buttonsModel = this.props.model.getParent();
    }
    else {
      // this.controls = this.props.meta.containers[0].controls;
      // this.buttonsModel = this.props.model.getParent();
    }
    // this.InitAreaColumns(this.getDemoAreaColumns());
  }

  setTimeInterval(num) {
    num = num || this.state.refreshInterval;
    if (this.timer)
      clearTimeout(this.timer);
    this.timer = setInterval(() => this.refreshData(), num);
  }

  componentDidUpdate() {
    if (this.gridModel)
      this.gridModel.addListener(this);
  }
  componentWillUnmount() {
    if (this.gridModel)
      this.gridModel.removeListener(this);
    this.timer && clearTimeout(this.timer);
    if (window.plus && window.plus.webview) {
      let wv = plus.webview.currentWebview();
      wv.setStyle({ 'scalable': 'false' });
    }
  }
  getAreaCaption(width, height, coordinate, captionFields) {
    let captionArr = [];
    let dataSourceEle = coordinate.dataSourceEle;
    dataSourceEle && captionFields && captionFields.forEach((ele, index) => {
      // let caption = _.get(data, ele.field) || "";
      let caption = commonFunc.getDataSourceFieldValue(_.get(dataSourceEle, ele.field), 1);
      if (caption != "") {
        caption = (ele.prefix || "") + caption + (ele.suffix || "");
      }
      captionArr.push(<div
        style={{
          textAlign: 'center',
          // fontWeight: 'bold',
          "whiteSpace": "nowrap",
          "overflow": "hidden",
          "textOverflow": "ellipsis"
        }}
        className={this.getClassName("AreaCaption_" + ele.field) + " " + this.getClassName("AreaCaptionIndex_" + index)}
      >{caption}</div>);
    })
    return <div className={this.getClassName("AreaCaptionList")} >
      {captionArr}
    </div>;
  }
  handleAreaClick(e, coordinate) {
    e.stopPropagation();
    let bSelected = (coordinate.id == this.state.selectedCoor.id ? false : true);
    this.setState({ selectedCoor: (bSelected ? coordinate : {}) })
    this.gridModel.select([coordinate.dataSourceIndex]);
    this.handleEvent(coordinate, commonFunc.sourceEvents.click);
    // console.log("单击选择的包房 coordinate.dataSourceIndex = " + coordinate.dataSourceIndex + " 行信息 = " + JSON.stringify(coordinate.dataSourceEle));
  }

  handleAreaDoubleClick(coordinate) {
    this.handleEvent(coordinate, commonFunc.sourceEvents.doubleClick);
    // console.log("双击选择的包房 coordinate.dataSourceIndex = " + coordinate.dataSourceIndex + " 行信息 = " + JSON.stringify(coordinate.dataSourceEle));
  }

  handleEvent(coordinate, sourceEvent) {
    // click doubleClick
    let triggerEvents = this.state.triggerEvents;
    let destEvent = triggerEvents && triggerEvents[sourceEvent];
    if (destEvent == commonFunc.destEvents.url) {
      this.openUrl(coordinate.url);
    }
    else if (destEvent == commonFunc.destEvents.drop) {
      // console.log("Do Drop");
      this.setState({ popoverCoor: coordinate });
    }
  }
  buttonClick(e, coordinate, ele) {
    e.stopPropagation();
    // e.preventDefault();
    this.state.popoverCoor = {};
    let btnModel = this.buttonsModel && this.buttonsModel.get(ele.cItemName);
    btnModel && btnModel.fireEvent('click', { index: coordinate.dataSourceIndex });
    this.setTimeInterval();
    this.refreshData();

  }
  getPopoverContent(coordinate) {
    // this.controls
    // this.buttonsModel
    let arr = [];
    this.controls && this.controls.forEach((ele, index) => {
      arr.push(
        <Button
          onClick={(e) => this.buttonClick(e, coordinate, ele)}
          className={this.getClassName("Popover-Btn")}>
          {ele.cShowCaption || cCaption}
        </Button>
      );
    });
    return <div className={this.getClassName("Popover-Btns")}>{arr}</div>;
  }
  wrapperPopover(coordinate, content) {
    let popoverContent = this.getPopoverContent(coordinate);
    let obj = <Popover
      // overlayStyle={{ width: "236px" }}
      content={popoverContent}
      visible={true}
      className={this.getClassName("Popover")}
      getPopupContainer={() => document.getElementById(this.getDivID(coordinate))}
    >
      <div className={this.getClassName("Popover-Div")}>
        {content}
      </div>
    </Popover>;
    return obj;
  }
  openUrl(url) {
    // console.log("Open URL url = " + url);
    this.winObj = window.open(url);
  }
  setDataSource = (data) => {
    data = data || [];
    let mapConfig = getNullMapConfig();
    if (data.length > 0) {
      let field = this.state.fieldMapping.mapConfigField;
      if (field) {
        {
          mapConfig = commonFunc.JSONParse(_.cloneDeep(data[0][field]));
          commonFunc.LogChartInfo("  热区显示图  通过返回的数据集获取 mapConfig 。 mapConfig  " + data[0][field], 901);
        }
      }
    }

    this.setDataInfoToCoordinates(mapConfig, data);
    this.setState({ areaDataList: data, mapConfig: mapConfig });
  }

  setDataInfoToCoordinates(mapConfig, data) {
    let field = this.state.fieldMapping.codeField;
    let coordinates = mapConfig.coordinates;
    if (field) {
      coordinates.forEach((coordinate) => {
        coordinate.dataSourceIndex = -1;
        coordinate.dataSourceEle = {};
        let dataSourceIndex = _.findIndex(data, function (ele) { return ele[field] == coordinate.code });
        if (dataSourceIndex >= 0) {
          coordinate.dataSourceIndex = dataSourceIndex;
          coordinate.dataSourceEle = data[dataSourceIndex];
        }
      });
    }
  }
  setColumns = (columndata) => {
  }
  setTitle = (titleList) => {
    // this.setState({
    //   titleList
    // });
  }
  setListenerState = (params) => {
  }
  setColumnByTtile = (columns) => {
    // this.columns = columns;
    // let columnset = this.RemodelingColumn(this.dataList, columns);
    // this.setState({ columnset });
  }
  getClassName(str) {
    let className = "HotAreaMapDisplay_" + str;
    if (!!this.state.extendClassName) {
      className = className + " " + this.state.extendClassName + "HotAreaMapDisplay_" + str
    }
    return className;
  }

  calcZoomInfo() {
    let tmpMapConfig = this.state.mapConfig;
    let configWidth = tmpMapConfig.width || 0;
    let configHeight = tmpMapConfig.height || 0;
    let divWidth = this.props.width || configWidth;
    let divHeight = this.props.height || configHeight;
    let rate = 1;
    if (configWidth && configHeight && divWidth && divHeight) {
      if (divWidth < configWidth || divHeight < configHeight) {
        let rate1 = divWidth / configWidth;
        let rate2 = divHeight / configHeight;
        rate = rate1 > rate2 ? rate2 : rate1;
        rate = rate.toFixed(6);
        rate = Math.floor(rate * 1000000) / 1000000;
      }
    }
    this.zoomInfo = { configWidth, configHeight, divWidth, divHeight, zoomRate: rate };
  }

  getRect(coordinate) {
    let self = this;
    let style = {};
    style.position = "absolute";
    style.left = this.calcZoomedCalue(coordinate.x);
    style.top = this.calcZoomedCalue(coordinate.y);
    style.width = this.calcZoomedCalue(coordinate.width);
    style.height = this.calcZoomedCalue(coordinate.height);
    // style.border = self.defaultAreaBorder;
    let styleContent = {};
    styleContent.width = style.width - 2;
    styleContent.height = style.height - 2;
    let tmpMapping = self.state.fieldMapping;
    let dataSourceEle = coordinate.dataSourceEle;
    let className = this.getClassName("Area");
    if (dataSourceEle) {
      if (dataSourceEle.backgroundImage) {
        style.backgroundImage = 'url(' + dataSourceEle.backgroundImage + ')';
        style.backgroundSize = '100% 100%';
      }
      let stateFieldValue = _.get(dataSourceEle, tmpMapping.stateField);
      stateFieldValue = commonFunc.getDataSourceFieldValue(stateFieldValue, 2);
      className = className + " " + this.getClassName("AreaState_" + stateFieldValue);
    }

    if (coordinate.id == this.state.selectedCoor.id) {
      className = className + " " + this.getClassName("Area_Selected");
    }
    let content = <div
      onClick={(e) => this.handleAreaClick(e, coordinate)}
      onDoubleClick={() => this.handleAreaDoubleClick(coordinate)}
      className={this.getClassName("Area_Content")}
      style={styleContent}>
      {self.getAreaCaption(style.width, style.height, coordinate, tmpMapping.captionFields)}
    </div>;
    if (coordinate.id == this.state.popoverCoor.id) {
      content = this.wrapperPopover(coordinate, content);
    }
    return <div id={this.getDivID(coordinate)} style={style} className={className} >{content}</div>;

  }
  getDivID(coordinate) {
    return "ID_" + coordinate.id;

  }
  getAreaArr(coordinates) {
    let obj = [];
    let self = this;
    coordinates.forEach((coordinate) => {
      let tmp;
      if (coordinate.hasOwnProperty("areaType") == false || coordinate.areaType == "rect") {
        //目前矩形，后面可能圆形或者多边形
        tmp = self.getRect(coordinate);
      }
      if (tmp)
        obj.push(tmp);
    });
    return obj;
  }
  MapClick() {
    this.setState({ popoverCoor: {} });
  }
  calcZoomedCalue(value) {
    let tmpValue = value * this.zoomInfo.zoomRate;
    return tmpValue;
  }
  render() {
    let self = this;
    let tmpMapConfig = this.state.mapConfig;
    this.calcZoomInfo();
    if (_.isEmpty(tmpMapConfig) == false && _.isEmpty(tmpMapConfig.imgUrl) == false) {
      let styleOuter = {};
      styleOuter.width = this.zoomInfo.divWidth;
      styleOuter.height = this.zoomInfo.divHeight;
      //styleOuter.overflow="hidden";
      //styleOuter.position="relative";
      if (commonFunc.isDebug) {
        styleOuter.border = "solid 1px red";
      }
      let styleMap = {};
      styleMap.backgroundImage = 'url(' + tmpMapConfig.imgUrl + ')';
      styleMap.width = this.calcZoomedCalue(tmpMapConfig.width);
      styleMap.height = this.calcZoomedCalue(tmpMapConfig.height);
      styleMap.backgroundSize = '100% 100%';
      // styleMap.backgroundRepeat = 'no-repeat';
      // styleMap.backgroundPosition = 'center';
      // styleMap.backgroundColor = "red";
      styleMap.position = "relative";
      let tmp = this.getAreaArr(tmpMapConfig.coordinates);
      return <div
        style={styleOuter}
        className={this.getClassName("MapOuter")}
        onClick={() => self.MapClick()}
      >
        <div id="room_ext_elem_s" style={styleMap} className={this.getClassName("Map")}>
          {tmp}
        </div >
      </div >;
    }
    else {
      commonFunc.LogChartInfo(" 热区显示图渲染 热区配置文件或者楼层图片为空。", 999);
      return <div className={this.getClassName("MapOuter")}>
        <div className={this.getClassName("MapNoData")} >
          <div className="table-nodata">
            <SvgIcon type="nodata" />
            暂时没有数据哦~
</div>
        </div>
      </div >;
    }

    // return <div   >
    //   <img src={config.mapBackPicUrl} border="10" useMap="#planetmap" alt="Planets" />
    //   <map name="planetmap" id="planetmap">
    //     <area
    //       shape="rect"
    //       coords="5,5,333,333"
    //       href="http://www.baidu.com"
    //       alt="Su1243n"
    //       // style={{ border: "dashed 2 red" }}
    //       style={{ borderWidth: 10, borderColor: "red" }}
    //       border={5}
    //       onClick={() => self.handleClick()}
    //     />
    //     {/* <area shape="circle" coords="180,139,14" href="venus.html" alt="Venus" style={{ borderWidth: 5 }} />
    //     <area shape="circle" coords="129,161,10" href="mercur.html" alt="Mercury" style={{ borderWidth: 5 }} />
    //     <area shape="rect" coords="0,0,110,260" href="sun.html" alt="Sun1234" style={{ borderWidth: 5 }} />
    //     <area shape="rect" coords="0,0,222,222" href="sun.html" alt="S1234un" style={{ borderWidth: 5 }} /> */}
    //   </map>
    // </div>

  }


  // InitAreaColumns(columns) {
  //   this.setState({ fieldMapping: tmp, areaColums: columns });
  // }
  refreshData() {
    let parentModel = this.gridModel.getCache("parent");
    parentModel && parentModel.execute('refresh');
  }

};
export default HotAreaMapDisplay



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/HotAreaMapDisplay.jsx